import { ErrorOutline } from '@mui/icons-material'
import { Chip, alpha, useTheme } from '@mui/material'
import { useTranslations } from 'next-intl'
import { useMemo } from 'react'

import type { Priority } from '~/data/types/notification'

type PriorityPillProps = {
  priority?: Priority
}

export default function PriorityPill({ priority }: PriorityPillProps) {
  const t = useTranslations('notifications.PriorityPill')
  const { error, warning, secondary } = useTheme().palette

  const color = useMemo(() => {
    switch (priority) {
      case 'Critical':
        return error.dark
      case 'High':
        return error.main
      case 'Medium':
        return warning.main
      case 'Low':
        return secondary.main
      default:
        return alpha(secondary.main, 0.04)
    }
  }, [priority, error, warning, secondary])

  if (!priority) return null

  return (
    <Chip
      icon={
        priority === 'Critical' ? (
          <ErrorOutline
            sx={{
              hight: 18,
              width: 18,
              color: `${error.contrastText} !important`
            }}
          />
        ) : undefined
      }
      label={t(priority)}
      size="small"
      sx={{
        color: error.contrastText,
        borderColor: error.contrastText,
        bgcolor: color
      }}
    />
  )
}
